import { DEFAULT_LANG } from './';
import { useState, useEffect } from 'react';
import type { ProviderChildren as Children, Langs } from './types';
import { Provider } from '@CS/components/TranslationProvider';

type ProviderProps = {
  children: Children;
  lang?: Langs;
};

export const TranslationProvider = ({
  lang: defaultLang,
  children
}: ProviderProps) => {
  const [lang, setLang] = useState(defaultLang ?? DEFAULT_LANG);

  useEffect(() => {
    if (defaultLang && defaultLang !== lang) {
      setLang(defaultLang);
    }
  }, [defaultLang, lang]);

  return <Provider value={lang}>{children}</Provider>;
};
